"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Page;
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactHelmet = _interopRequireDefault(require("react-helmet"));
var _reactIntl = require("react-intl");
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    page: {
      margin: '0 auto',
      maxWidth: 1400,
      padding: theme.spacing(2),
      width: '100%'
    }
  };
});
function Page(_ref) {
  var children = _ref.children,
    className = _ref.className,
    id = _ref.id,
    titleKey = _ref.titleKey;
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.page, className),
    id: id
  }, titleKey && /*#__PURE__*/_react.default.createElement(_reactHelmet.default, {
    title: formatMessage({
      id: titleKey
    })
  }), children);
}